import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Text,
} from "@chakra-ui/react";
import useCallCenter from "../../../call-center/hooks/useCallCenter";
import useInviteToCallModal from "../../../call-center/hooks/useInviteToCallModal";
import useInviteToCallMutation from "../../../call-center/hooks/useInviteToCallMutation";
import DialerTabs, { DialerTabsContext } from "../DialerTabs";

const inviteToCallDialerTabsContext: DialerTabsContext = {
  hideAgencyMembers: false,
  hideCaregivers: false,
  hidePatients: false,
  hidePhoneNumber: false,
  hidePhonebook: false,
  hideBotAgents: false,
};

export default function InviteToCallModal() {
  const modal = useInviteToCallModal();
  const invite = useInviteToCallMutation({ onSuccess: modal.onClose });
  const callCenter = useCallCenter();

  return (
    <Modal isOpen={modal.isOpen} size="xl" onClose={modal.onClose}>
      <ModalOverlay zIndex={10001} />
      <ModalContent containerProps={{ zIndex: 10001 }}>
        <ModalHeader>
          <Text>Invite to call</Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Progress isIndeterminate hidden={!modal.isOpen || !invite.isPending} size="xs" />
          {(() => {
            if (callCenter.state.currentCall === null) return;
            const callId = callCenter.state.currentCall.id;
            return (
              <DialerTabs
                context={inviteToCallDialerTabsContext}
                isCalling={invite.isPending}
                onClickAgencyMember={(id) =>
                  invite.mutate({ invitee: { type: "AgencyMember", id }, callId })
                }
                onClickDial={(invitee) => invite.mutate({ callId, invitee })}
              />
            );
          })()}
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
}
